export const paths = {
  OVERVIEW: '',
  BASKET: 'basket',
  NEW_PARCEL: 'new-parcel',
}

export const c2cLinks = {
  c2cLink: (): string => paths.OVERVIEW,
  c2cBasketLink: (): string => `/${paths.BASKET}`,
  c2cNewParcelLink: (): string => `/${paths.NEW_PARCEL}`,
}

export type C2CLinks = typeof c2cLinks
